/**
 * Browser address-bar query keys for report, activity, and leadership pages.
 * Laravel/OpenAPI still use reportTagId / reportTemplateId; map at the API client.
 * No aliases: reportTagId, reportTemplateId, and departmentId must not appear in SPA URLs.
 */
export const REPORT_SPA_QUERY_PARAMS = {
  TEMPLATE_ID: "rtid",
  TAG_ID: "tid",
  DEPARTMENT_ID: "did",
} as const;

export function parsePositiveSpaId(value: string | null | undefined): number {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function parseReportViewSearch(search: URLSearchParams): {
  departmentId: number;
  reportTagId: number;
} {
  return {
    departmentId: parsePositiveSpaId(search.get(REPORT_SPA_QUERY_PARAMS.DEPARTMENT_ID)),
    reportTagId: parsePositiveSpaId(search.get(REPORT_SPA_QUERY_PARAMS.TAG_ID)),
  };
}

export function buildReportViewSearch(args: {
  departmentId: number;
  reportTagId: number;
}): string {
  const params = new URLSearchParams();
  params.set(REPORT_SPA_QUERY_PARAMS.DEPARTMENT_ID, String(args.departmentId));
  params.set(REPORT_SPA_QUERY_PARAMS.TAG_ID, String(args.reportTagId));
  return params.toString();
}

export type ReportListFilterIds = {
  departmentId?: number;
  reportTagId?: number;
  reportTemplateId?: number;
};

export function parseReportListFilterSearch(search: URLSearchParams): ReportListFilterIds {
  const departmentId = parsePositiveSpaId(search.get(REPORT_SPA_QUERY_PARAMS.DEPARTMENT_ID));
  const reportTagId = parsePositiveSpaId(search.get(REPORT_SPA_QUERY_PARAMS.TAG_ID));
  const reportTemplateId = parsePositiveSpaId(search.get(REPORT_SPA_QUERY_PARAMS.TEMPLATE_ID));
  return {
    ...(departmentId > 0 ? { departmentId } : {}),
    ...(reportTagId > 0 ? { reportTagId } : {}),
    ...(reportTemplateId > 0 ? { reportTemplateId } : {}),
  };
}

export function buildReportListFilterSearch(ids: ReportListFilterIds): Record<string, string> {
  const filters: Record<string, string> = {};
  if (ids.departmentId && ids.departmentId > 0) {
    filters[REPORT_SPA_QUERY_PARAMS.DEPARTMENT_ID] = String(ids.departmentId);
  }
  if (ids.reportTagId && ids.reportTagId > 0) {
    filters[REPORT_SPA_QUERY_PARAMS.TAG_ID] = String(ids.reportTagId);
  }
  if (ids.reportTemplateId && ids.reportTemplateId > 0) {
    filters[REPORT_SPA_QUERY_PARAMS.TEMPLATE_ID] = String(ids.reportTemplateId);
  }
  return filters;
}
